export default __webpack_public_path__ + "static/ApercuLAPhil-Medium-c7953319e7246b5274a36d6e78e76caf.eot";